/**
 * Returns a value constrained by the specified min and max bounds.
 * @param value The value to clamp.
 * @param min The minimum the value can be.
 * @param max The maximum the value can be.
 */
export function clamp(value: number, min: number, max: number) {
  if (value < min) value = min;
  if (value > max) value = max;
  return value;
}

const B = 4.3279;

/**
 * Penalize the given score. A higher penalty will cause a middle score to skew high.
 * @param penalty The penalty between -1.0 and 1.0.
 * @param score The score between -1.0 and 1.0.
 */
export function penalize(penalty: number, score: number): number {
  return clamp(
    Math.log(
      (score / (B * Math.pow(Math.E, -penalty)) + 0.5) /
        (1 - score / (B * Math.pow(Math.E, -penalty)) - 0.5)
    ),
    -1,
    1
  );
}
